var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"facebook","d":"M14.78,3.491H16.7V.148A24.783,24.783,0,0,0,13.9,0C11.136,0,9.241,1.741,9.241,4.94V7.884H6.187v3.737H9.241v9.4h3.744v-9.4h2.93l.465-3.737h-3.4V5.31c0-1.08.292-1.819,1.8-1.819Z","transform":"translate(-6.188)","fill":"#e4e4e4"}));
}

FacebookIcon.defaultProps = {"width":"10.512","height":"21.023","viewBox":"0 0 10.512 21.023"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
